import { useRouter } from 'next/router';
import Link from 'next/link';

export default function SidebarLinkH({ disabled, children, isActive, onClick }) {
  const router = useRouter();

  
  const classNames = 'border-b-4 px-3 py-2 mb-4 text-xs cursor-pointer';

  if (disabled)
    return (
      <li className={`${classNames} border-transparent cursor-not-allowed text-gray-500`}>
        {children}
      </li>
    );
  return (
    <li
      style={{ display: "inline-block" }}
      className={`${classNames} ${isActive ? 'text-blue-400' : 'text-gray-700 border-transparent hover:text-gray-600'
        } `}
      onClick={onClick}
    >
      <a>{children}</a>
    </li>
  );
}
